import React, { useEffect, useState } from 'react';
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { selectTicketsListItems } from '../../../../../redux/tickets/selector';
import { useSelector } from 'react-redux';

export default function EventsBookingModal({ Close, selectEvents, onInnerBasicFormChange }: any) {
  const ticketsItems = useSelector(selectTicketsListItems);
  const [selectedTicket, setSelectedTicket] = useState<any>(null);
  const [quantity, setQuantity] = useState<number>(1);

  useEffect(() => {
    const defaultTicket = ticketsItems?.result?.items?.[0];
    if (defaultTicket) {
      setSelectedTicket(defaultTicket);
    }
  }, [ticketsItems]);

  const handleBookTicket = () => {
    onInnerBasicFormChange?.({
      ...selectedTicket,
      quantity,
    });
  };

  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-xl font-bold text-center text-indigo-700 mb-6">Book Your Ticket</h2>

      {selectedTicket ? (
        <div className="bg-white border border-indigo-200 rounded-xl p-6 shadow-md space-y-4">
          <div>
            <p className="text-md text-gray-800 mb-1">Ticket:</p>
            <p className="font-semibold text-indigo-700">{selectedTicket?.Name}</p>
          </div>

          <div>
            <label className="block text-sm font-medium text-indigo-700 mb-2">
              Number of Tickets
            </label>
            <input
              type="number"
              min={1}
              className="w-full border border-indigo-300 rounded-md px-3 py-2"
              value={quantity}
              onChange={(e) => setQuantity(Number(e.target.value))}
            />
          </div>

          <div className="flex justify-end gap-4 pt-4">
            <button
              className="px-4 py-2 bg-gray-300 text-gray-800 rounded-md hover:bg-gray-400"
              onClick={Close}
            >
              Cancel
            </button>
            <button
              className="px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700"
              onClick={handleBookTicket}
            >
              Book Now
            </button>
          </div>
        </div>
      ) : (
        <p className="text-gray-600 text-center">No tickets available for this event.</p>
      )}
    </div>
  );
}
